<template>
    <div class="grid p-fluid animate__animated animate__fadeIn">
        <div class="col-12 md:col-12">
            <div class="card card-w-title">
                <HeaderBar createButton="true" @new-event="addItem = true" title="مدیریت اسلایدر صفحه اصلی" />


                <div v-if="!loading">
                    <div v-if="homePageSliderManagment.length">
                        <DataTable ref="dt" :value="homePageSliderManagment" dataKey="id"
                            class="overflow-hidden border-round-2xl shadow-1 mt-5 animate__animated animate__fadeIn"
                            responsiveLayout="scroll">
                            <Column field="title" header="عنوان" headerStyle="width:14%; min-width:10rem;">
                                <template #body="slotProps">
                                    {{ slotProps.data.title }}
                                </template>
                            </Column>
                            <Column field="subTitle" header="توضیحات" headerStyle="width:14%; min-width:10rem;">
                                <template #body="slotProps">
                                    {{ slotProps.data.subTitle }}
                                </template>
                            </Column>
                            <Column field="isActive" header="وضعیت" headerStyle="width:14%; min-width:10rem;">
                                <template #body="slotProps">
                                    <Button @click="changeActiveStatus(slotProps.data.id, slotProps.data.isActive)"
                                        :icon="`pi pi-${slotProps.data.isActive ? 'check' : 'times'}`"
                                        class="p-button-rounded p-button-secondary"
                                        :class="`p-button-rounded p-button-${slotProps.data.isActive ? 'success' : 'danger'}`"
                                        v-tooltip.top="'تغییر وضعیت'" />
                                </template>
                            </Column>
                            <Column header="عملیات">
                                <template #body="slotProps">
                                    <Button icon="pi pi-pencil" v-tooltip.top="'ویرایش'"
                                        class="p-button-rounded p-button-secondary ml-2"
                                        @click="editPlace(slotProps.data.id)" />
                                    <Button icon="pi pi-trash" v-tooltip.top="'حذف'"
                                        class="p-button-rounded p-button-warning mt-2"
                                        @click="confirmDeletePlace(slotProps.data)" />
                                </template>
                            </Column>
                            <Column header="جابجایی">
                                <template #body="slotProps">
                                    <Button @click="swapOrderPlace(slotProps.data)" icon="pi pi-external-link"
                                        class="p-button-rounded p-button-secondary"
                                        :class="{ 'p-button-success': swapOrderPlaceData.FirstPlaceId == slotProps.data.id }, { 'p-button-success': swapOrderPlaceData.SecondPlaceId == slotProps.data.id }" />
                                </template>
                            </Column>

                        </DataTable>
                    </div>
                    <div v-if="!homePageSliderManagment.length" class="text-center mt-5">
                        <h5> موردی وجود ندارد</h5>
                    </div>
                </div>


            </div>
        </div>



        <!----------------------------- modal ----------------------------->
        <Dialog v-model:visible="addItem" :style="{ width: '600px' }" header="ایجاد مکان" :modal="true" class="p-fluid">
            <div>
                <InputText v-model="placeData.title" dir="rtl" placeholder="عنوان" class="mb-5 mt-3" />
                <InputText v-model="placeData.subTitle" dir="rtl" placeholder="توضیحات" class="mb-5 mt-3" />
                <div class="col-12 md:col-12">
                    <MultiSelect v-model="placeData.placeIds" :options="allWithBriefInfo" filter optionLabel="name"
                        placeholder="انتخاب مکان" optionValue="id" class="w-full">
                        <template #footer>
                            <div class="py-2 px-3">
                                {{ ` موارد انتخاب شده ${placeData.placeIds.length} عدد` }}
                            </div>
                        </template>
                    </MultiSelect>
                </div>


            </div>
            <template #footer>
                <Button label="لغو" icon="pi pi-times" class="p-button-text" @click="addItem = false" />
                <Button :disabled="loadingUpdate" type="submit" class="p-button-text" label="ایجاد" icon="pi pi-check"
                    @click="postHomePlacesGalleryManagement" />
            </template>
        </Dialog>
        <!----------------------------- deletePlaceDialog ----------------------------->
        <Dialog v-model:visible="deletePlaceDialog" :style="{ width: '450px' }" header="حذف" :modal="true">
            <div class="flex flex-column align-items-center justify-content-center">
                <i class="pi pi-exclamation-triangle" style="font-size: 4rem" />
                <span class="mt-3">آیا مطمئن هستید؟</span>
            </div>
            <template #footer>
                <div class="text-center">
                    <Button label="خیر" icon="pi pi-times" class="p-button-text" @click="deletePlaceDialog = false" />
                    <Button label="بلی" icon="pi pi-check" class="p-button-text" @click="removePlace" />
                </div>
            </template>
        </Dialog>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            loading: true,
            loadingUpdate: false,
            addItem: false,
            deletePlaceDialog: false,
            editPlaceModal: false,
            editPlaceModalData: null,
            title: null,
            editPlaceModalDataImage: null,
            mode: 0,
            modeSelection: [
                { type: "کاشی", value: 0 },
                { type: "اسلایدر", value: 1 },
            ],
            homePageSliderManagment: {},
            allWithBriefInfo: [],
            placeData: {
                placeIds: [],
                title: null,
                subTitle: null
            },
            placeId: null,
            swapOrderPlaceData: {
                FirstPlaceId: null,
                SecondPlaceId: null
            },
        };
    },
    methods: {
        async getHomePageSliderManagment() {
            this.loading = true;
            await this.axios.get(`HomePageSliderManagment/slider`).then((data) => {
                this.homePageSliderManagment = data.data
                this.loading = false;
            })
        },
        async getAllWithBriefInfo() {
            await this.axios.get(`Place/GetAllWithBriefInfo`).then((data) => {
                this.allWithBriefInfo = data.data.data
            })
        },
        async postHomePlacesGalleryManagement() {
            await this.axios.post('HomePageSliderManagment/slider', this.placeData).then(() => {
                this.addItem = false
                this.placeData.title = null
                this.placeData.subTitle = null
                this.placeData.placeIds = []
                this.getHomePageSliderManagment()
                this.showToast(200);
            })
        },
        async changeActiveStatus(id, status) {
            let data = {
                isActive: !status
            }
            await this.axios.patch(`HomePageSliderManagment/slider/${id}/changeActiveStatus`, data).then(() => {
                this.getHomePageSliderManagment();
                this.showToast(200);
            })
        },
        editPlace(id) {
            this.$router.push(`/HomePageSliderManagment/edit?id=${id}`);
        },
        confirmDeletePlace(data) {
            this.placeId = data.id
            this.deletePlaceDialog = true
        },
        async removePlace() {
            await this.axios.delete(`HomePageSliderManagment/slider/${this.placeId}`).then(() => {
                this.deletePlaceDialog = false
                this.getHomePageSliderManagment();
                this.showToast(200);
            })
        },
        swapOrderPlace(data) {
            if (this.swapOrderPlaceData.FirstPlaceId) {
                if (this.swapOrderPlaceData.FirstPlaceId != data.id) {
                    this.swapOrderPlaceData.SecondPlaceId = data.id
                    this.postSwapOrderPlace();
                }
                else {
                    this.swapOrderPlaceData.FirstPlaceId = null
                    this.swapOrderPlaceData.SecondPlaceId = null
                }
            }
            else {
                this.swapOrderPlaceData.FirstPlaceId = data.id
            }
        },
        async postSwapOrderPlace() {
            let data = {
                firstId: this.swapOrderPlaceData.FirstPlaceId,
                secondId: this.swapOrderPlaceData.SecondPlaceId
            }
            await this.axios.patch('HomePageSliderManagment/slider/orderSwap', data).then(() => {
                this.swapOrderPlaceData.FirstPlaceId = null
                this.swapOrderPlaceData.SecondPlaceId = null
                this.getHomePageSliderManagment();
                this.showToast(200);
            })
        },
        imageConvertBlob(picture) {
            return URL.createObjectURL(picture);
        },
        onUpload(event) {
            this.placeData.image = event.target.files[0]
        },
        onUploadEdit(event) {
            this.editPlaceModalData.image = event.target.files[0]
        },
    },
    mounted() {
        this.getHomePageSliderManagment();
        this.getAllWithBriefInfo();
    },
};
</script>
  
<style lang="scss" scoped>
.file-uploader {
    width: auto;
    margin: 0;
    display: inline-flex;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    align-items: center;
    -align: bottom;
    text-averticallign: center;
    overflow: hidden;
    position: relative;
    background: #4f46e5;
    color: #ffffff;
    border-color: #4f46e5;
    padding: 1rem 1.25rem;
    font-size: 1rem;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    border-radius: 6px;

    &:focus {
        box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #b1b3f8, 0 1px 2px 0 black;
        outline: 0 none;
        outline-offset: 0;
    }
}

.remove-picture {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
        transition-delay: all 0.8s ease-in-out;
        visibility: hidden;
    }

    &:hover {
        i {
            visibility: visible;
        }
    }
}
</style>
  